var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('sys-server-table',{attrs:{"headers":_vm.headers,"tableData":_vm.tableData,"pagination":_vm.pagination,"items":_vm.items,"title":_vm.title,"error_message":_vm.error_message,"update_route":_vm.update_route,"create_route":_vm.create_route},on:{"getItems":_vm.getItems}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1400943a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/configs/Configs.vue
// module id = null
// module chunks = 